'use client'

export function AccentStrip() {
  return <div className="w-full h-1" style={{ background: 'var(--ms-accent)' }} />
}
